import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from '../actions';
import { tap, mergeMap, map, catchError, switchMap } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { OutletService, SearchService } from 'app/services';

@Injectable()
export class OutletsEffects {
  constructor(
    private actions$: Actions,
    private outletService: OutletService,
    private searchService: SearchService
  ) {}

  loadOutletsContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.setOutlets),
      mergeMap(action =>
        this.getContents$(action).pipe(
          switchMap(response => [
            actions.setOutletsSuccess({
              contents: { ...response }
            })
          ]),
          catchError(err => of(actions.setOutletsError({ payload: err })))
        )
      )
    )
  );

  getContents$(action): Observable<any> {
    if (action.isSearch) {
      return this.searchService.search(
        action.searchBody,
        action.sort,
        'outlets',
        action.page,
        action.size
      );
    } else {
      return this.outletService.getOutletForTopic(
        action.topicId,
        action.sort,
        action.page,
        action.size
      );
    }
  }
}
